import { hasHrAccessToken } from 'services/session/authSession'

export const retryProtectedQuery = (failureCount, error, maxRetries = 3) => {
  const status = error?.status || error?.response?.status
  if (error?.isAuthError) return false
  if (status >= 400 && status < 500) return false
  return failureCount < maxRetries
}

export const protectedQueryRefetchInterval = () =>
  hasHrAccessToken() ? 15000 : false

export const protectedPollingInterval = (interval) => (...args) => {
  if (!hasHrAccessToken()) return false
  return typeof interval === 'function' ? interval(...args) : interval
}
